import { Leaf, Sparkles, Flower2, Star } from "lucide-react";
import Reveal, { Eyebrow } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";

const ICONS = [Leaf, Sparkles, Flower2, Star];

export default function QualitySection() {
  const { t } = useLanguage();
  return (
    <section className="border-y hairline bg-coal/40 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <Eyebrow>{t.quality.eyebrow}</Eyebrow>
          <h2 className="mt-6 max-w-xl font-serif text-4xl leading-tight text-cream sm:text-5xl">
            {t.quality.heading}
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {t.quality.items.map((q, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={q.t} delay={i * 0.1} className="h-full">
                <div
                  data-testid={`quality-card-${i + 1}`}
                  className="group h-full border hairline bg-velvet/40 p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-gold/40 hover:shadow-[0_0_40px_rgba(212,175,55,0.1)]"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-full border border-gold/40 bg-gold/5 text-gold transition-all duration-500 group-hover:bg-gold group-hover:text-obsidian">
                    <Icon className="h-5 w-5" strokeWidth={1.5} />
                  </span>
                  <h3 className="mt-7 font-serif text-xl text-cream">{q.t}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-cream/60">{q.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
